module.exports = __webpack_public_path__ + "media/images/ohap_manage roster_off-bf147009c9a73500c4b2ac319b3c99a8.png";